import React, { Ref } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';

import useLoadMoreData from '../useLoadMoreData';

const DefaultLoadMore = ({
  inViewRef,
  onLoad,
}: Pick<ReturnType<typeof useLoadMoreData>, 'inViewRef' | 'onLoad'>) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <LinkButton
      ref={inViewRef as Ref<HTMLButtonElement>}
      data-testid="loadMore"
      onClick={onLoad}
      size={LinkButton.SIZES.SMALL}
    >
      {T.translate('LOAD_MORE')}
    </LinkButton>
  );
};

export default DefaultLoadMore;
